<!-- 公共底部 -->
<template>
  <div class="footer_wrap">
    <div class="left">
      <img
        style="width: 120px; position: relative; top: -5px"
        src="../assets/img/u66.png"
        alt=""
      />
    </div>
    <ul class="left">
      <li>北京盈科千信科技有限公司</li>
      <li>地址： 北京市海淀区中关村南大街48号</li>
    </ul>
    <ul class="right">
      <li>邮箱： product@increscence.net</li>
      <li>
        Copyright © {{ year }}
        <img src="../assets/img/copy_n.png" alt="" />
        <a
          href="https://beian.miit.gov.cn"
          target="_blank"
          style="color: #8a8989"
          >京ICP备15054044号-1</a
        >
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      year: new Date().getFullYear(), //当前年份
    };
  },
};
</script>
<style scoped lang='less'>
.footer_wrap {
  display: flex;
  width: 100%;

  // min-width: 1350px;
  height: 80px;
  // width: 52.5%;
  margin: auto;
  // padding: 0 0 0 60px;
  // min-width: 1800px;
  //  min-width: 1920px;
  //   max-width: 2500px;
  justify-content: center;
  align-items: center;
position: relative;
left: -65px;
  // background: #fd8d1c;
}
.left {
  // width: 125px;
  //   font-size: 18px !important;
  // font-size: 16px;
  margin-right: 30px;
  color: #8a8989;
  font-size: 12px !important;
  img {
    width: 100%;
    height: 100%;
  }
  li + li {
    // margin-top: 14px;
  }
}
li {
  line-height: 25px !important;
}
.right {
  font-size: 12px !important;
  // font-size: 16px;
  border-left: 2px solid #c5c2c2;
  color: #8a8989;
  padding-left: 30px;
  //   color: rgb(0, 0, 0);
  //   font-size: 10px;
  a {
    // color: rgb(8, 8, 8);
  }
  li {
    // line-height: 20px;
    line-height: 25px !important;
  }
  img {
    width: 20px;
    vertical-align: middle;
  }
}
</style>